import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_routes',
};

export const getRoutesRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
